module.exports = __webpack_public_path__ + "img/50.39bae764.png";